module.exports = __webpack_public_path__ + "static/img/Two of Swords.306d2cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Two of Swords.jpg
// module id = 1331
// module chunks = 0